<div class="center">
  <mat-card id = "style-4" class="cardcomponentMasks">
    <div class="arx-calendar">
      <iframe width="1500" height="800" src="https://app.powerbi.com/view?r=eyJrIjoiOWZiOGE0M2UtZTgwMS00N2M3LTkyNWUtZGQwZjE2NWU0ZTQzIiwidCI6IjMyZjEwMmZlLTQ3MTgtNGJlMS1hNWMzLTIxNzAyOTkwOTA1NCIsImMiOjl9" frameborder="0" allowFullScreen="true"></iframe>    </div>
  </mat-card>
</div>

